import { createSlice } from '@reduxjs/toolkit';
import { PACS_URL } from '@custom/constant';

const initialState = {
  showAISelectionCheckbox: false,
  aiSelectedImages: [],
}

const convertToWadorsUrl = (inputString) => {
  const regex = /studies-(.+?)-series-(.+?)-instances-(.+?)-frames-(\d+)\.png/;
  const match = inputString.match(regex);

  if (match) {
    const [ , studyId, seriesId, instanceId, frameId ] = match;
    return `wadors:${PACS_URL}/dcm4chee-arc/aets/DCM4CHEE/rs/studies/${studyId}/series/${seriesId}/instances/${instanceId}/frames/${frameId}`;
  }
  return null;
};

const aiImageSelectionSlice = createSlice({
  name: 'report/aiImageSelection',
  initialState,
  reducers: {
    toggleAISelectionCheckbox: (state, {payload}): void => {
      state.showAISelectionCheckbox = payload;
      // state.aiSelectedImages.length = 0;
    },
    addAIImage: (state, {payload}): void => {
      state?.aiSelectedImages?.push(payload);
    },
    removeAIImage: (state, {payload}): void => {
      const temp = state?.aiSelectedImages?.filter(image => image.imgName !== payload);
      state.aiSelectedImages = temp;
    },
    setAISelectedImages: (state, {payload}) => {
      if(payload){
        state.aiSelectedImages = payload?.map((item)=>{
          return {imgName: convertToWadorsUrl(item), imgData: item};
        });
      }
    }
  },
});

export const { addAIImage, removeAIImage, toggleAISelectionCheckbox, setAISelectedImages } = aiImageSelectionSlice.actions;
export default aiImageSelectionSlice.reducer;
